'use client'
// import { LogoutLink } from '@kinde-oss/kinde-auth-nextjs'
import dynamic from 'next/dynamic'
import { usePathname } from 'next/navigation'
import { useContext, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import BuildInfo from './translate/build-info'
import { languageModalId } from './translate/lang-selector/lang-selector'
import { themeModalId } from './translate/options/theme-modal'
import { userModalId } from './translate/options/user-modal'
import { showModal } from './translate/util/modal'
import { UserContext } from './translate/util/user-context'
// chunks it but doesn't release build size?
const LogoutLink = dynamic(() =>
    import('@kinde-oss/kinde-auth-nextjs').then((mod) => ({
        default: mod.LogoutLink,
    }))
)

// type Props = { user: User }
const Menu = () => {
    const pathname = usePathname()
    const { commitHash = '' } = useContext(UserContext)
    const dialogRef = useRef<HTMLDetailsElement>(null)
    const [isOpen, setIsOpen] = useState(!!dialogRef.current?.open)
    const closeDialog = () => {
        dialogRef.current?.toggleAttribute('open')
    }
    return (
        <div className="flex-none">
            <details
                id="options-details"
                className="dropdown dropdown-end"
                ref={dialogRef}
                onToggle={() => {
                    setIsOpen(!!dialogRef.current?.open)
                }}
            >
                <summary className="list-none">
                    <div className="btn btn-square btn-ghost">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            className="inline-block h-5 w-5 stroke-current"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                            ></path>
                        </svg>
                    </div>
                </summary>
                <div>
                    <ul className="menu dropdown-content z-1 rounded-box bg-base-100 absolute w-36 p-2 drop-shadow-lg">
                        {pathname === '/translate' && (
                            <>
                                <li onClick={closeDialog}>
                                    <label onClick={() => showModal(languageModalId)}>Languages</label>
                                </li>
                                <li onClick={closeDialog}>
                                    <label onClick={() => showModal(themeModalId)}>Theme</label>
                                </li>
                            </>
                        )}
                        <li onClick={closeDialog}>
                            <label onClick={() => showModal(userModalId)}>Account</label>
                        </li>
                        <li>
                            <LogoutLink>Log out</LogoutLink>
                        </li>
                        {commitHash && (
                            <li>
                                <BuildInfo commitHash={commitHash} />
                            </li>
                        )}
                    </ul>
                </div>
            </details>
            {isOpen && createPortal(<div className="bg-base fixed inset-0" onClick={closeDialog}></div>, document.body)}
        </div>
    )
}
export default Menu
